<template>
  <vue-modal :active="active" type="small" @closed="$emit('closed')">
    <vue-filters @applied="$modal.close('orders-filters')">
      <h3 class="border-b border-gray-lighter pb-2 mb-4">Filtrer</h3>
      <div class="mb-8">
        <div class="flex items-center">
          <span class="w-1/3 mr-2">Famille</span>
          <vue-filter-family param="families" track-by="id" multiple/>
        </div>
      </div>
      <div class="mb-8">
        <div class="flex items-center">
          <span class="w-1/3 mr-2">Produit</span>
          <vue-filter-product param="products" track-by="id" multiple/>
        </div>
      </div>
      <div class="mb-8">
        <div class="flex items-center">
          <span class="w-1/3 mr-2">Boutique</span>
          <vue-filter-shop param="shops" track-by="id" multiple/>
        </div>
      </div>
      <div class="mb-8">
        <div class="flex items-center">
          <span class="w-1/3 mr-2">Date</span>
          <vue-filter-date param="pickupDate" class="w-full"/>
        </div>
      </div>
      <div class="mb-8">
        <div class="flex items-center">
          <span class="w-1/3 mr-2">Type de client</span>
          <vue-filter-customer-type param="customerType" class="w-full"/>
        </div>
      </div>
    </vue-filters>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import VueFilters from '../filters/Filters.vue';
import VueFilter from '../filters/Filter.vue';
import VueFilterFamily from '../filters/FilterFamily.vue';
import VueFilterProduct from '../filters/FilterProduct.vue';
import VueFilterShop from '../filters/FilterShop.vue';
import VueFilterDate from '../filters/FilterDate.vue';
import VueFilterCustomerType from '../filters/FilterCustomerType.vue';

export default {
  components: {
    VueFilters,
    VueFilter,
    VueFilterFamily,
    VueFilterProduct,
    VueFilterShop,
    VueFilterDate,
    VueFilterCustomerType,
  },

  mixins: [modal],
};
</script>
